import api from "./api";

export const getInvoiceSettings = () => {
  return api.get("/invoice-settings");
};

export const updateInvoiceSettings = (data) => {
  return api.put("/invoice-settings", data);
};
